import React from 'react';

import { redWaglLogo } from '../../../assets/images/';
import Button from '../../../components/Button';
import { navigateTo } from '../../../contrib/Utils/navigateTo';

const Start = () => (
  <div className="start-player wrapper">
    <div className="start-player-top override">
      <h1 className="start-player-top__title">Welcome to</h1>
      <img src={redWaglLogo} className="start-player-top__logo" alt="Logo" />
      <p className="start-player-top__tagline">CREATE YOUR BEST GOLF EXPERIENCE</p>
    </div>
    <div className="start-player-bottom override">
      <Button
        id="login"
        onClick={navigateTo('/login')}
        variant="contained"
        color="primary"
        className="start-player-bottom__button button--shadow"
      >
        LOGIN
      </Button>
      <Button
        id="invitation"
        onClick={navigateTo('/register/set-code')}
        variant="outlined"
        color="primary"
        className="start-player-bottom__button"
      >
        I HAVE AN INVITATION CODE
      </Button>
    </div>
  </div>
);

export { Start };
